var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},_vm._l((_vm.projects),function(project){return _c('div',{key:project.title,staticClass:"col-md-4"},[_c('project-card',_vm._b({},'project-card',project,false))],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }